import { ChangeObject, diffChars } from 'diff';

function stringDiff({
  oldValue = '',
  newValue = '',
}: {
  oldValue?: string;
  newValue?: string;
}) {
  const diff: ChangeObject<string>[] = diffChars(oldValue, newValue);
  let oldDiffValue: string = '';
  let newDiffValue: string = '';
  for (let j = 0; j < diff.length;) {
    if (!diff[j].added) {
      oldDiffValue += `<span style="color: ${diff[j].removed ? 'red' : 'black'}">${diff[j].value}</span>`;
    }
    if (!diff[j].removed) {
      newDiffValue += `<span style="color: ${diff[j].added ? 'green' : 'black'}">${diff[j].value}</span>`;
    }
    j += 1;
  }
  return {
    hasChanged: oldDiffValue !== newDiffValue,
    oldValue: oldDiffValue,
    newValue: newDiffValue,
  };
}

export default stringDiff;
